import React, { useEffect, useState } from "react";

export default function ProductShipping({

    product,

    shipping,

    onSave

}) {

    const [form, setForm] = useState({

        shippingClass: "",

        shippingRequired: true,

        freeShipping: false,

        shippingFee: 0,

        additionalItemFee: 0,

        deliveryMinDays: 2,

        deliveryMaxDays: 7,

        pickupAvailable: false,

        pickupInstructions: "",

        localDeliveryAvailable: false,

        localDeliveryFee: 0,

        localDeliveryRadius: 0,

        requiresSignature: false,

        isFragile: false,

        requiresSpecialHandling: false,

        fulfillmentType: "brand",

        shippingNotes: ""

    });

    const [saving, setSaving] =
        useState(false);

    useEffect(() => {

        if (!shipping) {
            return;
        }

        setForm({

            shippingClass:
                shipping.shippingClass || "",

            shippingRequired:
                shipping.shippingRequired ??
                true,

            freeShipping:
                shipping.freeShipping ??
                false,

            shippingFee:
                shipping.shippingFee || 0,

            additionalItemFee:
                shipping.additionalItemFee ||
                0,

            deliveryMinDays:
                shipping.deliveryMinDays ||
                2,

            deliveryMaxDays:
                shipping.deliveryMaxDays ||
                7,

            pickupAvailable:
                shipping.pickupAvailable ||
                false,

            pickupInstructions:
                shipping.pickupInstructions ||
                "",

            localDeliveryAvailable:
                shipping.localDeliveryAvailable ||
                false,

            localDeliveryFee:
                shipping.localDeliveryFee ||
                0,

            localDeliveryRadius:
                shipping.localDeliveryRadius ||
                0,

            requiresSignature:
                shipping.requiresSignature ||
                false,

            isFragile:
                shipping.isFragile ||
                false,

            requiresSpecialHandling:
                shipping.requiresSpecialHandling ||
                false,

            fulfillmentType:
                shipping.fulfillmentType ||
                "brand",

            shippingNotes:
                shipping.shippingNotes ||
                ""

        });

    }, [shipping]);

    const update = (
        field,
        value
    ) => {

        setForm(prev => ({

            ...prev,

            [field]: value

        }));

    };

    const save = async () => {

        try {

            setSaving(true);

            await onSave(
                product.id,
                form
            );

        }

        finally {

            setSaving(false);

        }

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2>
                    Shipping & Fulfillment
                </h2>

                <p
                    style={{
                        color: "#666"
                    }}
                >
                    Configure how this product
                    is delivered, shipped or
                    collected.
                </p>

            </div>

            <section
                style={{
                    background: "#fff",
                    padding: 25,
                    borderRadius: 14
                }}
            >

                <h3>
                    Shipping
                </h3>

                <label>

                    Shipping Class

                    <input
                        value={
                            form.shippingClass
                        }
                        onChange={e =>
                            update(
                                "shippingClass",
                                e.target.value
                            )
                        }
                    />

                </label>

                <label>

                    Shipping Fee

                    <input
                        type="number"
                        value={
                            form.shippingFee
                        }
                        onChange={e =>
                            update(
                                "shippingFee",
                                Number(
                                    e.target.value
                                )
                            )
                        }
                    />

                </label>

                <label>

                    <input
                        type="checkbox"
                        checked={
                            form.freeShipping
                        }
                        onChange={e =>
                            update(
                                "freeShipping",
                                e.target.checked
                            )
                        }
                    />

                    Free Shipping

                </label>

            </section>

            <section
                style={{
                    background: "#fff",
                    padding: 25,
                    borderRadius: 14
                }}
            >

                <h3>
                    Delivery Window
                </h3>

                <input
                    type="number"
                    value={
                        form.deliveryMinDays
                    }
                    onChange={e =>
                        update(
                            "deliveryMinDays",
                            Number(
                                e.target.value
                            )
                        )
                    }
                />

                <input
                    type="number"
                    value={
                        form.deliveryMaxDays
                    }
                    onChange={e =>
                        update(
                            "deliveryMaxDays",
                            Number(
                                e.target.value
                            )
                        )
                    }
                />

            </section>

            <section
                style={{
                    background: "#fff",
                    padding: 25,
                    borderRadius: 14
                }}
            >

                <h3>
                    Pickup
                </h3>

                <label>

                    <input
                        type="checkbox"
                        checked={
                            form.pickupAvailable
                        }
                        onChange={e =>
                            update(
                                "pickupAvailable",
                                e.target.checked
                            )
                        }
                    />

                    Customer Pickup Available

                </label>

                {form.pickupAvailable && (

                    <textarea
                        placeholder="Pickup instructions"
                        value={
                            form.pickupInstructions
                        }
                        onChange={e =>
                            update(
                                "pickupInstructions",
                                e.target.value
                            )
                        }
                    />

                )}

            </section>

            <section
                style={{
                    background: "#fff",
                    padding: 25,
                    borderRadius: 14
                }}
            >

                <h3>
                    Fulfillment
                </h3>

                <select
                    value={
                        form.fulfillmentType
                    }
                    onChange={e =>
                        update(
                            "fulfillmentType",
                            e.target.value
                        )
                    }
                >

                    <option value="brand">
                        Brand Fulfilled
                    </option>

                    <option value="marketplace">
                        Marketplace Fulfilled
                    </option>

                    <option value="third_party">
                        Third-party Fulfillment
                    </option>

                    <option value="digital">
                        Digital
                    </option>

                </select>

            </section>

            <section
                style={{
                    background: "#fff",
                    padding: 25,
                    borderRadius: 14
                }}
            >

                <h3>
                    Special Handling
                </h3>

                <label>

                    <input
                        type="checkbox"
                        checked={
                            form.isFragile
                        }
                        onChange={e =>
                            update(
                                "isFragile",
                                e.target.checked
                            )
                        }
                    />

                    Fragile

                </label>

                <label>

                    <input
                        type="checkbox"
                        checked={
                            form.requiresSignature
                        }
                        onChange={e =>
                            update(
                                "requiresSignature",
                                e.target.checked
                            )
                        }
                    />

                    Signature Required

                </label>

                <label>

                    <input
                        type="checkbox"
                        checked={
                            form.requiresSpecialHandling
                        }
                        onChange={e =>
                            update(
                                "requiresSpecialHandling",
                                e.target.checked
                            )
                        }
                    />

                    Special Handling Required

                </label>

            </section>

            <button
                onClick={save}
                disabled={saving}
                style={{
                    alignSelf: "flex-start",
                    padding: "13px 25px",
                    border: "none",
                    borderRadius: 10,
                    background:
                        "rgb(255,0,204)",
                    color: "#fff",
                    fontWeight: 700,
                    cursor: "pointer"
                }}
            >

                {saving
                    ? "Saving..."
                    : "Save Shipping Settings"}

            </button>

        </div>

    );

}